import { connect } from 'react-redux';

import VariantPrice from '../components/VariantPrice';
import { variantWithSku } from 'common/selectors';

const mapStateToProps = (state, props) => {
  const variant = variantWithSku(props.variantSku, state);

  return {
    isMembershipOrder: state.currentOrder.membership_order,
    membershipDiscountRate: state.membershipDiscountRate,
    baseAmount: variant === null ? 0.0 : parseFloat(variant.price),
    isSubscribable: variant === null ? false : variant.is_subscribable,
    subscribableVariantDiscountRate: state.subscribableVariantDiscountRate,
  };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VariantPrice);
